import { useEffect, useState } from "react";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

// O tema do sistema é a classe `dark` no <html> (ver AdminConfiguracoesPerfil), não o
// next-themes: sem ThemeProvider, o useTheme devolvia "system" e o aviso seguia o tema
// do Windows, escuro sobre a tela clara.
function useTemaDoSistema(): "light" | "dark" {
  const ler = () => (document.documentElement.classList.contains("dark") ? "dark" : "light");
  const [tema, setTema] = useState<"light" | "dark">(ler);
  useEffect(() => {
    const observador = new MutationObserver(() => setTema(ler()));
    observador.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
    return () => observador.disconnect();
  }, []);
  return tema;
}

// Mesmo visual do Toaster do Radix (ui/toast.tsx): canto, borda, espaçamento e erro em
// vermelho cheio — os dois sistemas convivem e o aviso não pode mudar de cara conforme a tela.
const Toaster = ({ ...props }: ToasterProps) => {
  const tema = useTemaDoSistema();

  return (
    <Sonner
      theme={tema}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:rounded-md group-[.toaster]:p-4 group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          error:
            // `!`: as classes de `toast` acima também casam e, sem prioridade, o título ficava preto no vermelho.
            "group-[.toaster]:!bg-destructive group-[.toaster]:!text-destructive-foreground group-[.toaster]:!border-destructive",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
